import { createFileRoute, redirect } from '@tanstack/react-router'
import { ActivityLogPage } from '../pages/ActivityLogPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/activity' as any)({
    component: ActivityLogPage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})
